import { ApplicationQuestion } from '@features/applicationQuestions';

export const mockApplicationQuestion = (
  overrides?: Partial<ApplicationQuestion>,
) => ({
  label: 'Industry experience',
  question: '<p>Do you have previous experience working in this industry?</p>',
  ...overrides,
});

export const APPLICATION_QUESTION_MOCK = mockApplicationQuestion();
